import { useState, useEffect } from "react";
import MyDropzoneComponent from "../../components/modal/DropZone";
import TinyMCEEditor from "../../components/modal/TinyMce";
import { useAppDispatch, useAppSelector } from "src/store";
import { showCategories } from "src/store/kategorija-store";
import { Post } from "src/components/shared/models";
import moment from "moment";
import {
  addPost,
  removePostCategory,
  resetPosts,
  updatePost,
} from "src/store/objave-store";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { STATUS_OBJAVE, TYPE_OBJAVE } from "src/data/helper";
import LinkDokumenta from "src/components/shared/LinkDokumenta";

interface Props {
  data?: Post;
  id?: string;
  is_edit: boolean;
  searchData: any;
}

function ObjaveForm({ is_edit, data, id, searchData }: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { categories } = useAppSelector((state) => state.category);
  const { CEsuccess, loading } = useAppSelector((state) => state.post);

  const [categoryError, setCategoryError] = useState("");
  const [images, setImages] = useState<any>(data ? data.data.images : []);
  const [documents, setDocuments] = useState<any>(
    data ? data.data.documents : []
  );

  const [thumbnail, setThumbnail] = useState<any>(
    data ? [data.data.image] : []
  );
  const [categoriesCheck, setCategoriesCheck] = useState<any[]>(
    data && data.data
      ? data?.data.categories.map((category) => {
          return category.id.toString();
        })
      : []
  );

  const formik = useFormik({
    initialValues: {
      status: data ? data.data.status : "",
      content: data ? data.data.content : "",
      title: data ? data.data.title : "",
      date_created: data ? new Date(data.data.date_created) : new Date(),
      type: data ? data.data.type : "",
      date_of_expiry:
        data && data.data && data.data.date_of_expiry
          ? new Date(data.data.date_of_expiry)
          : null,
    },
    onSubmit: (values: any) => {
      const formData = new FormData();

      if (categoriesCheck.length === 0) {
        setCategoryError("Kategorija je obavezno polje.");
        return;
      }

      if (values.title) {
        formData.append("title", values.title);
      }

      if (values.content) {
        formData.append("content", values.content);
      } else {
        formData.append("content", "");
      }

      if (values.type) {
        formData.append("type", values.type);
      }

      if (values.status) {
        formData.append("status", values.status);
      }

      images !== data?.data.images &&
        images.forEach((image: any) => {
          formData.append("images[]", image);
        });

      documents !== data?.data.documents &&
        documents.forEach((document: any, index: number) => {
          if (document && !document.id) {
            formData.append(
              `documents[${index}][path]`,
              document && document.link ? document.link : document
            );
            formData.append(
              `documents[${index}][order]`,
              document.order ? document.order : index + 1
            );
            formData.append(`documents[${index}][lang]`, "en");
            formData.append(
              `documents[${index}][display_name]`,
              document.display_name || document.name
            );
          }
        });

      categoriesCheck.forEach((category) => {
        const findCategory =
          data && data.data.categories.find((x: any) => +x.id === +category);
        if (!findCategory) {
          formData.append("categories[]", category);
        }
      });

      if (thumbnail && thumbnail[0] && thumbnail[0] !== data?.data.image) {
        formData.append("image", thumbnail[0]);
      }

      const dateToSend = moment(values.date_created).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      formData.append("date_created", dateToSend);

      if (values.date_of_expiry) {
        const expityDate = moment(values.date_of_expiry).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        formData.append("date_of_expiry", expityDate);
      }

      setDocuments([]);

      if (is_edit) {
        formData.append("_method", "PUT");
        dispatch(updatePost({ formData, id }));
      } else {
        dispatch(addPost(formData));
      }
    },
    validationSchema: Yup.object({
      title: Yup.string().required(),
      date_created: Yup.string().required(),
    }),
  });

  const handleCheckbox = (e: any) => {
    const { value, checked } = e.target;

    if (checked) {
      setCategoriesCheck([...categoriesCheck, value]);
    } else {
      if (id) {
        dispatch(removePostCategory({ postId: id, categoryId: value }));
      }
      setCategoriesCheck(categoriesCheck.filter((x) => x !== value));
    }
  };

  useEffect(() => {
    if (CEsuccess) {
      toast.success("Success");
      navigate(
        `/objave?page=${searchData.page}&search[title]=${
          searchData["search[title]"] || ""
        }`
      );
    }
  }, [CEsuccess, dispatch, navigate, searchData]);

  useEffect(() => {
    dispatch(showCategories({ per_page: 30 }));
    dispatch(resetPosts());
  }, [dispatch]);

  return (
    <div className="novaobjava">
      <div className="title-first row g-2 align-items-center">
        <div className="col">
          <h2 className="page-title">Nova objava</h2>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-cards">
          <div className="col-md-8">
            <div className="card">
              <div className="card-body">
                <div className="tab-content">
                  <div>
                    <div className="mb-3">
                      <label className="form-label">
                        Naslov <span className="form-required-filed">*</span>
                      </label>
                      <input
                        type="text"
                        name="title"
                        className="form-control"
                        placeholder="Naslov objave"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                      />
                      {formik.touched.title && formik.errors.title && (
                        <div className="form-error-message">
                          Naslov je obavezno polje
                        </div>
                      )}
                    </div>
                    <label className="form-label">Opis</label>
                    <div>
                      <TinyMCEEditor
                        value={formik.values.content}
                        name="content"
                        formik={formik}
                      />
                      {formik.touched.content && formik.errors.content && (
                        <div className="form-error-message">
                          Sadržaj je obavezno polje
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="card">
                <div className="card-body">
                  <h3 className="card-title">Fotografije</h3>
                  <MyDropzoneComponent
                    setValue={setImages}
                    type="images"
                    values={images}
                    id={id}
                    buttonText="Izaberite fotografije"
                    accept={{ "image/png": [".png", ".jpeg", ".jpg"] }}
                  />
                </div>
              </div>
            </div>
            <div>
              <div className="card">
                <div className="card-header"></div>
                <div className="card-body">
                  <div className="tab-content">
                    <div>
                      <h3 className="card-title">Dokumenta</h3>
                      <MyDropzoneComponent
                        setValue={setDocuments}
                        // saveForm={handleSave}
                        values={documents}
                        type="documents"
                        id={id}
                        buttonText="Izaberite dokumenta"
                        is_edit={is_edit}
                        single={false}
                        accept={{
                          "application/pdf": [".pdf"],
                          "application/msword": [".doc"],
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                            [".dpcx"],
                          "application/vnd.ms-excel": [".xls"],
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                            [".xlsx"],
                          "application/vnd.ms-powerpoint": [".ppt"],
                          "application/vnd.openxmlformats-officedocument.presentationml.presentation":
                            [".pptx"],
                          "text/csv": [".csv"],
                          "application/rtf": [".rtf"],
                          "application/zip": [".zip"],
                          "application/x-zip-compressed": [".zip"],
                          "application/x-bzip": [".bz"],
                          "application/x-bzip2": [".bz2"],
                          "application/gzip": [".gz"],
                          "application/x-gzip": [".gz"],
                          "application/x-7z-compressed": [".7z"]
                        }}
                      />
                    </div>

                    <div className="text-end card-footer">
                      <LinkDokumenta
                        setDocuments={setDocuments}
                        loading={loading}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card">
              <div className="card-body">
                <h3 className="card-title">
                  Datum objave <span className="form-required-filed">*</span>
                </h3>
                <div className="input-icon mb-3">
                  <DatePicker
                    showIcon
                    selected={formik.values.date_created}
                    onChange={(date: any) =>
                      formik.setFieldValue("date_created", date)
                    }
                    showTimeInput
                    className="form-control w-100"
                  />
                </div>

                <h3 className="card-title">Datum važenja objave</h3>
                <div className="input-icon mb-3">
                  <DatePicker
                    showIcon
                    selected={formik.values.date_of_expiry}
                    onChange={(date: any) =>
                      formik.setFieldValue("date_of_expiry", date)
                    }
                    showTimeInput
                    className="form-control w-100"
                  />
                </div>

                <div className="mb-3">
                  <h3 className="card-title">Status</h3>
                  {STATUS_OBJAVE.map((status: any, index: number) => (
                    <label key={index} className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value={status.value}
                        checked={status.value === formik.values.status}
                        onChange={(e) =>
                          formik.setFieldValue("status", status.value)
                        }
                      />
                      <span className="form-check-label">{status.label}</span>
                    </label>
                  ))}

                  {formik.touched.status && formik.errors.status && (
                    <div className="form-error-message">
                      Status je obavezno polje
                    </div>
                  )}
                </div>

                <div className="mb-3">
                  <h3 className="card-title">Tip objave</h3>
                  {TYPE_OBJAVE.map((type: any, index: number) => (
                    <label key={index} className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        value={type.value}
                        checked={type.value === formik.values.type}
                        onChange={(e) =>
                          formik.setFieldValue("type", type.value)
                        }
                      />
                      <span className="form-check-label">{type.label}</span>
                    </label>
                  ))}

                  {formik.touched.type && formik.errors.type && (
                    <div className="form-error-message">
                      Tip je obavezno polje
                    </div>
                  )}
                </div>
                <h3 className="card-title">
                  Kategorija <span className="form-required-filed">*</span>{" "}
                </h3>
                <div className="mb-3">
                  <div>
                    {categories &&
                      categories.data &&
                      categories.data.map((category: any) => (
                        <label key={category.id} className="form-check">
                          <input
                            className="form-check-input"
                            checked={
                              categoriesCheck.find(
                                (x) => x === category.id.toString()
                              )
                                ? true
                                : false
                            }
                            onChange={handleCheckbox}
                            type="checkbox"
                            value={category.id}
                          />
                          <span className="form-check-label">
                            {category.name}
                          </span>
                        </label>
                      ))}
                  </div>

                  {categoryError && (
                    <div className="form-error-message">{categoryError}</div>
                  )}
                </div>
                <h3 className="card-title">Naslovna fotografija</h3>
                <MyDropzoneComponent
                  setValue={setThumbnail}
                  values={thumbnail}
                  id={id}
                  type="thumb"
                  buttonText="Izaberite naslovnu fotografiju"
                  accept={{ "image/png": [".png", ".jpeg", ".jpg"] }}
                  single={true}
                />
              </div>
              <div className="text-end card-footer">
                <button
                  disabled={loading}
                  type="submit"
                  className="btn btn-primary btnSubmit"
                >
                  {loading ? "U obradi..." : "Sačuvaj"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ObjaveForm;
